var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSteering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17C13.4183 17 17 13.4183 17 8.99999C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 8.99999C1 13.4183 4.58172 17 9 17Z",
    stroke: "#888888",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00021 10.7782C9.98204 10.7782 10.778 9.98227 10.778 9.00043C10.778 8.01859 9.98204 7.22266 9.00021 7.22266C8.01837 7.22266 7.22243 8.01859 7.22243 9.00043C7.22243 9.98227 8.01837 10.7782 9.00021 10.7782Z",
    stroke: "#888888",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.778 9.00043L16.778 7.22266M9.00021 10.7782V17.0004V10.7782ZM7.22243 9.00043L1.22243 7.22266L7.22243 9.00043Z",
    stroke: "#888888",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteering);
export default __webpack_public_path__ + "static/media/steering.644fe597f8c70d133cb89aeab0cf26be.svg";
export { ForwardRef as ReactComponent };